import { render } from "./Termos.vue?vue&type=template&id=7037e1bc&scoped=true"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"

import "./Termos.vue?vue&type=style&index=0&id=7037e1bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7037e1bc"]])

export default __exports__